import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-toolbox/lib/button';
import { get } from '~/actions/tasks';
import Tag from '~/components/Tag';
import style from './style.scss';

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    this.load();
  }

  getStatus() {
    const { task, parents } = this.props;
    if (task.resolution) {
      return task.resolution.type;
    }
    if (parents.find(p => p.resolution === undefined)) {
      return 'blocked';
    }
    return 'pending';
  }

  load() {
    if (!this.props.id || !this.props.task) {
      this.setState({ loading: false });
      return;
    }

    get(this.props.dispatch, this.context.apiClient, this.props.id)
      .then(() => this.setState({ loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  renderTask() {
    const { task, parents, className, onEdit, ...rest } = this.props;
    const status = this.getStatus();
    return (
      <div className={[style.task, className].join(' ')} onClick={() => this.context.dialogPush('task', { id: task.id })} {...rest}>
        <div className={style.title}>
          #{task.sku} - {task.type}
          <div className={[style.status, status === 'done' && style.green, status === 'skip' && style.yellow, status === 'blocked' && style.grey, status === 'fail' && style.red, status === 'abort' && style.red].join(' ')}>{status}</div>
        </div>
        <div className={onEdit && style.left}>
          {task.userId && <Tag type="user" id={task.userId} />}
          {task.containerId && <Tag type="container" id={task.containerId} />}
          {task.orderId && <Tag type="order" id={task.orderId} />}
          {task.locationId && <Tag type="location" id={task.locationId} />}
          {status === 'blocked' && <div>
            Blocked by:&nbsp;
            {Object.values(parents).filter(p => p.resolution === undefined)
              .map(parent => <Tag key={parent.id} type="task" id={parent.id} />)}
          </div>}
        </div>
        {onEdit && <div className={style.right}>
          <Button label="Edit" primary raised onClick={() => onEdit()} />
        </div>}
        {!onEdit && task.removed && <div className={style.removed}>REMOVED</div>}
      </div>
    );
  }

  render() {
    const { id, task, className, parents, dispatch, ...props } = this.props;

    if (this.state.loading) { return <div className={[style.task, className].join(' ')} {...props}>Loading</div>; }
    if (task) { return this.renderTask(); }
    return <div className={[style.task, className].join(' ')} {...props}>404</div>;
  }
}

const mapStateToProps = (state, props) => {
  const task = state.getIn(['tasks', 'items', props.id]);
  if (!task) { return { task: null }; }
  return {
    task: task.toJS(),
    parents: Object.values(state.getIn(['tasks', 'items']).toJS()).filter(t => task.get('parentTaskId', []).includes(t.id)),
  };
};

export default connect(mapStateToProps)(Dialog);



// WEBPACK FOOTER //
// ./app/components/Task/index.js